"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSeizeInfo = void 0;
const FlowConfig_1 = __importDefault(require("@/class/FlowConfig"));
const utils_1 = require("@/config/utils");
const router_1 = __importDefault(require("@/pages/index/router"));
const seizeFlowConfig = new FlowConfig_1.default({
    list: [
        'ufo_cs_cf_10',
        'ufo_cs_cf_20',
        'ufo_cs_cf_30',
        'ufo_cs_cf_40',
        'ufo_cs_cf_50',
        'ufo_cs_cf_60',
        'ufo_cs_cf_70',
        'ufo_cs_cf_80', // 结束
    ]
});
const toSeizeInfo = function (seizeId, flowId, flowKey) {
    if (flowKey === 'start') {
        flowKey = seizeFlowConfig.getBuild();
    }
    else if (flowKey === 'end') {
        flowKey = seizeFlowConfig.getEnd();
    }
    router_1.default.push(`/litigation/seize/info/${seizeId}/${(0, utils_1.simpleEncrypt)(flowId)}/${(0, utils_1.simpleEncrypt)(flowKey)}`);
};
exports.toSeizeInfo = toSeizeInfo;
exports.default = seizeFlowConfig;
